var map = {
	"./assembler.png": 799,
	"./preSolderer.png": 800,
	"./qa_inspector.png": 801,
	"./rework_operator.png": 802,
	"./shipper.png": 803,
	"./solderer.png": 804,
	"./stakingPressOperator.png": 805,
	"./wireStripper.png": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 798;